import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'amountToWords'
})
export class AmountToWordsPipe implements PipeTransform {

  private ones: string[] = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
    'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
  ];

  private tens: string[] = [
    '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
  ];

  private thousands: string[] = [
    '', 'Thousand', 'Million', 'Billion'
  ];

  transform(value: number): string {
    if (value < 0) return 'minus ' + this.convert(Math.abs(value));
    return this.convert(value);
  }

  private convert(value: number): string {
    if (value === 0) return 'zero';
    let words: string = '';
    let chunkIndex = 0;

    while (value > 0) {
      let chunk = value % 1000;
      if (chunk > 0) {
        words = this.chunkToWords(chunk) + (this.thousands[chunkIndex] ? ' ' + this.thousands[chunkIndex] : '') + ' ' + words;
      }
      value = Math.floor(value / 1000);
      chunkIndex++;
    }

    return words.trim();
  }

  private chunkToWords(value: number): string {
    let words: string = '';

    if (value > 99) {
      words += this.ones[Math.floor(value / 100)] + ' hundred ';
      value %= 100;
    }

    if (value > 19) {
      words += this.tens[Math.floor(value / 10)] + ' ';
      value %= 10;
    }

    if (value > 0) {
      words += this.ones[value] + ' ';
    }

    return words.trim();
  }
}
